<template>
  <div class="pa-4">
    <div style="font-size: 1em;text-align: center;"> 
        <div style="text-align: left;">
          <img style="width:60px;height:60px;object-fit:cover;border-radius:50%;" :src="userFile(this.$store.state.academyImage)" />
        </div>
        <div style="text-align:center;">
          <h2>{{documentName}}</h2>
        </div>
        <div style="text-align:left;font-size:0.8em" v-html="documentContents">
        </div>
        <div style="text-align:left;margin-top:50px">
          <table width="100%"><tr :key="'ef_'+i._id" v-for="i in extraFields">
            <td>
              <div style="width: 400px;border-top: 1px black solid; margin-top: 50px">
                {{ i.fieldName }}
              </div>
            </td>
            <td></td>
          </tr>
            <tr>
              <td width="70%">
                <div style="width: 400px;border-top: 1px black solid;margin-top: 50px">
                  {{$t('message.name_student')}}
                </div>
              </td>
              <td>
              </td>
            </tr>
            <tr>
              <td>
                <div style="width: 400px;border-top: 1px black solid; margin-top: 50px">
                  {{$t('message.name_guardian')}}
                </div>
              </td>
              <td></td>
            </tr>
            <tr>
              <td>
                <div style="width: 400px;border-top: 1px black solid; margin-top: 50px">
                  {{$t('message.signature_student_guardian')}}
                </div>
              </td>
              <td>
                <div style="width: 200px;border-top: 1px black solid;margin-top: 50px">
                  {{$t('message.date')}}
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
  </div>
</template>

<script>
import Api from '@/services/Api';

export default {
  data() {
    return {
      lang: this.$route.params.lang,
      id: this.$route.params.id,
      preview: this.$route.query.preview,
      documentContents: this.$t('message.loading'),
      documentName: null,
      extraFields: [],
    };
  },
  components: {
  },
  created() {
    if(this.id){
      Api().get('documents/academy/'+this.$store.state.managedAcademy+'/templates/' + this.id)
          .then(response => {
            if(response){
              const document = response.data;
              if (document.extraFields && document.extraFields.length > 0) {
                this.extraFields = document.extraFields;
              }
              var found = false;
              if(this.lang ==  document.lang){
                this.documentContents = document.contents;
                found = true;
              }else{
                for(const c in document.contentTransaltions){
                  if(c == this.lang){
                    this.documentContents = document.contentTransaltions[this.lang];
                    found = true;
                  }
                }
              }
              this.documentName = document.name;
              if(!found)
                this.documentContents = document.contents;
              if(!this.preview)
              window.print();
            }
          }).catch(e => {
            if(e)
              this.showAlert("error", "Oops!", this.$t('message.error_generic'));
        });
    }
  },
  watch: {

  },
  methods: {
  }
};
</script>

<style scoped>
.waiver{
  font-family: 'Bradley Hand';
  color: black
}
</style>